import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from '@finder/shared/utils/object/isEmpty';

@Pipe({
    name: 'idGenerator',
    standalone: true
})
export class IdGeneratorPipe implements PipeTransform {

    transform(value: string | number, ...args: string[]): string {
        if (isEmpty(value) || !args.length) {
            return '';
        }

        return `${args.join('-')}-${value}`;
    }
}
